import momentJalaali from "moment-jalaali";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import moment from 'jalali-moment';
import jalaali from 'jalaali-js';


export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const convertPersianToEnglish = (persianNumber) => {
  const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
  const englishDigits = "0123456789";
  return persianNumber
    .split("")
    .map((char) => {
      const index = persianDigits.indexOf(char);
      return index !== -1 ? englishDigits[index] : char;
    })
    .join("");
};

const persianMonths = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

export function unixToPersianDay(unix) {
  if (!unix) {
    return "-";
  }
  const momentObj = momentJalaali.unix(unix);

  const day = momentObj.format("jDD");
  const monthIndex = momentObj.format("jM") - 1;
  const year = momentObj.format("jYYYY");

  const formattedDate = `${day} ${persianMonths[monthIndex]} ${year}`;

  return formattedDate;
}
export function unixToPersianTime(unix) {
  if (!unix) {
    return "-";
  }
  const momentObj = momentJalaali.unix(unix);

  const time = momentObj.format("HH:mm");

  const formattedTime = `${time}`;

  return formattedTime;
}


// export const convertToJalali = (gregorianDate) => {
//   return moment(gregorianDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSSZ')
//       .locale('fa')
//       .format('(HH:mm) YYYY/MM/DD ');
// };
